<section class="main-section usercenter-section p-3">
  <header class="d-md-flex d-block justify-content-between align-items-center main-heading">
    <div class="d-flex align-items-center">
      <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
        role="button" aria-controls="offcanvasExample">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
        </svg></a>
      <h3 class="heading-span text-black">
        <span>Ticket Management</span>
      </h3>
    </div>
    <div class="d-flex">
      <div class="d-flex">
        <div class="input-group me-0 user-center-search">
          <span class="input-group-text bg-transparent" id="basic-addon1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M19 19L15.71 15.71" stroke="#999999" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <input type="text" [(ngModel)]="searchTerm" class="form-control usercenter-searchcontrol ps-0 bg-white"
            placeholder="Search" aria-label="Username" aria-describedby="basic-addon1" (keyup.enter)="ApplySearch()" />
        </div>
        <mat-icon matTooltipPosition="above" matTooltip="Search by Ticket ID / Subject / Description" tooltipClass="FigTree-Regular"
          class="fs-22 m-2">info</mat-icon>
      </div>
      <div class="d-flex">
        <button *ngIf="!userRole?.includes(roles.SuperAdmin)" type="button"
          class="btn theme-btn px-md-5 px-2 me-0 me-sm-0 mb-0 ms-3" (click)="openRaiseTicketModal()">
          Raise a Ticket
        </button>
      </div>
    </div>
  </header>
  <div class="bg-white d-flex justify-content-between align-items-center radius8 mb-4 py-2"
    *ngIf="userRole?.includes(roles.AccountAdmin)">
    <div class="tabs mb-0">
      <ul *ngIf="userRole?.includes(roles.AccountAdmin)" class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button (click)="changeTab(tabs.MyTickets)" class="nav-link active" id="active-user-tab" data-bs-toggle="tab"
            [class.active]="activeTab === tabs.MyTickets" data-bs-target="#active-user-tab-pane" type="button"
            role="tab" aria-controls="active-user-tab-pane" aria-selected="true">
            <span>My Tickets</span>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button (click)="changeTab(tabs.AccountTickets)" class="nav-link" id="inactive-user-tab" data-bs-toggle="tab"
            data-bs-target="#inactive-user-tab-pane" [class.active]="activeTab === tabs.AccountTickets" type="button"
            role="tab" aria-controls="inactive-user-tab-pane" aria-selected="false">
            <span>Account Tickets</span>
          </button>
        </li>
      </ul>
    </div>

  </div>
  <div class="tab-content">
    <div>
      <div class="table-responsive tab-table ticket-management-table">
        <table  class="table table-hover">
          <thead>
            <tr>
              <th class="firstName-header">S.No</th>
              <th class="lastName-header">Ticket ID</th>
              <th *ngIf="isAssignedTicketsLoaded" class="contactNumber-header">Raised By</th>
              <th *ngIf="isAssignedTicketsLoaded" class="contactNumber-header">Name
                <mat-icon *ngIf="sortNameAsc"
                  (click)="sortNameAsc=false;getSortedTicketData('Name','asc')">arrow_upward</mat-icon>
                <mat-icon *ngIf="!sortNameAsc"
                  (click)="sortNameAsc=true;getSortedTicketData('Name','desc')">arrow_downward</mat-icon>
              </th>
              <th class="contactNumber-header">Subject</th>
              <th class="action-header">Description</th>
              <th class="contactNumber-header">Attachment</th>
              <th *ngIf="!userRole?.includes(roles.AccountAdmin)" class="action-header">Assigned to
                <mat-icon *ngIf="sortAssignedToAsc"
                  (click)="sortAssignedToAsc=false;getSortedTicketData('AssignedTo','asc')">arrow_upward</mat-icon>
                <mat-icon *ngIf="!sortAssignedToAsc"
                  (click)="sortAssignedToAsc=true;getSortedTicketData('AssignedTo','desc')">arrow_downward</mat-icon>
              </th>
              <th class="lastName-header">Status</th>
              <th class="action-header sticky-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ticket of ticketDetails; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ ticket.ticketName }}</td>
              <td *ngIf="isAssignedTicketsLoaded">{{ ticket.matAccountName || ticket.raisedByName || 'Account Admin' }}
              </td>
              <td *ngIf="isAssignedTicketsLoaded">{{ ticket.ticketCreatorName }}</td>
              <td>{{ ticket.ticketSubject }}</td>
              <td>
                <p class="mat-account-detail read-more-detail mb-0">
                  {{ ticket.ticketDescription }}</p>
                <a *ngIf="ticket.ticketDescription.length > 40"
                  (click)="viewTicketDescriptionModal(ticket.ticketDescription)" class="fw700 text-black">Readmore</a>
              <td class="text-center">
                <span class="cursor-pointer" *ngIf="ticket.uploadedFileUrl[0] && ticket.uploadedFileUrl[0].length > 0"
                  (click)="viewUploadedFilesModal(ticket.uploadedFileUrl[0])">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.00033 11.332V7.33203L4.66699 8.66536" stroke="#5D847B" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6 7.33203L7.33333 8.66536" stroke="#5D847B" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M14.6663 6.66536V9.9987C14.6663 13.332 13.333 14.6654 9.99967 14.6654H5.99967C2.66634 14.6654 1.33301 13.332 1.33301 9.9987V5.9987C1.33301 2.66536 2.66634 1.33203 5.99967 1.33203H9.33301"
                      stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M14.6663 6.66536H11.9997C9.99967 6.66536 9.33301 5.9987 9.33301 3.9987V1.33203L14.6663 6.66536Z"
                      stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <div class="mb-0" *ngIf="!ticket.uploadedFileUrl[0]">
                  <div class="mt-0 p-0 ticket-file-input">
                    <div class="">
                      <input hidden type="file" #fileInput (change)="onFileSelected($event,ticket)" />
                      <button type="button" class="btn px-0 ms-0 border-sm-0" mat-raised-button (click)="fileInput.click()">
                        <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#5D847B"><path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
                      </button>
                    </div>
                    <p class="file-name w50 text-truncate">{{ ticket.selectedFileName }}</p>
                  </div>
                </div>
              </td>
              <td *ngIf="!userRole?.includes(roles.AccountAdmin)">
                <p class="mb-0">
                  {{ ticket.assignedTo }}
                </p>
              </td>
              <td>
                <span (click)="addTicketCommentModal(ticket.ticketId)" class="cursor-pointer badge-progress fs-12"
                  [ngClass]="{
                    'badge-new': ticket.ticketStatus === 'New',
                    'badge-in-progress': ticket.ticketStatus === 'InProgress',
                    'badge-on-hold': ticket.ticketStatus === 'OnHold',
                    'badge-completed': ticket.ticketStatus === 'Closed'
                  }">
                  {{ ticket.ticketStatus }}
                </span>
              </td>
              <td class="sticky-right">
                <ng-container>
                  <a class="btn-action" matTooltip="View ticket details"
                    (click)="viewTicketCommentModal(ticket.ticketCommentDetails)">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.9833 9.99993C12.9833 11.6499 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.6499 7.0166 9.99993C7.0166 8.34993 8.34993 7.0166 9.99993 7.0166C11.6499 7.0166 12.9833 8.34993 12.9833 9.99993Z"
                        stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M10.0001 16.8918C12.9418 16.8918 15.6834 15.1584 17.5918 12.1584C18.3418 10.9834 18.3418 9.00843 17.5918 7.83343C15.6834 4.83343 12.9418 3.1001 10.0001 3.1001C7.05845 3.1001 4.31678 4.83343 2.40845 7.83343C1.65845 9.00843 1.65845 10.9834 2.40845 12.1584C4.31678 15.1584 7.05845 16.8918 10.0001 16.8918Z"
                        stroke="#5D847B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </a>
                  <a class="btn-action" matTooltip="View ticket details"
                    (click)="addTicketCommentModal(ticket.ticketId)">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M9.90845 4.20825C10.2668 6.50825 12.1334 8.26658 14.4501 8.49992" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M2.5 18.3333H17.5" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                   </svg>
                  </a>
                  <a *ngIf="!isAssignedTicketsLoaded && loggedInUserId == ticket.raisedByUserId" class="btn-action"
                    matTooltip="Delete ticket details" (click)="deleteRaiseTicketModal(ticket.ticketId)">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z"
                        fill="#5D847B" />
                    </svg>
                  </a>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-paginator *ngIf="ticketDetails?.length" [length]="totalRecords" [pageSize]="pageSize"
        [pageIndex]="pageNumber" (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100]">
      </mat-paginator>
      <div *ngIf="!ticketDetails.length" class="noDataFound">
        <h1>{{'No Data Found'}}</h1>
      </div>
    </div>
  </div>
</section>